var _rect, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCopyButtonIcon = function SvgCopyButtonIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 5,
    fill: "#5656FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5854 7.18848H13.3275C12.651 7.18848 12.1008 7.73888 12.1008 8.41514V18.6729C12.1008 19.3491 12.651 19.8995 13.3275 19.8995H23.5854C24.2619 19.8995 24.8121 19.3491 24.8121 18.6729V8.41514C24.8121 7.73888 24.2619 7.18848 23.5854 7.18848ZM23.2121 18.2995H13.7008V8.78848H23.2121V18.2995ZM18.3007 23.2107H8.78945V13.6996H11.4785V12.0996H8.41612C7.73964 12.0996 7.18945 12.65 7.18945 13.3263V23.584C7.18945 24.2603 7.73964 24.8107 8.41612 24.8107H18.674C19.3505 24.8107 19.9007 24.2603 19.9007 23.584V20.5218H18.3007V23.2107Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCopyButtonIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CopyButtonIcon.942da0fb.svg";
export { ForwardRef as ReactComponent };